module.exports = __webpack_public_path__ + "static/media/9.0e7761e4.jpg";